import React, { useState } from 'react';
import {
  Backdrop,
  Modal,
  Fade,
  Typography,
  Paper,
  Button,
  Box,
  Grid,
} from '@mui/material';
import { Input } from 'components/layout';
import { useTranslation } from 'react-i18next';
import { FormProvider, useForm } from 'react-hook-form';
import { FormChipList, FormMonacoEditor } from 'components/common';
import { useTheme } from '@mui/material/styles';


export default function InventoryHostModal(props) {
  const {
    open,
    handleClose,
    onSubmitCreate,
    onSubmitEdit,
    defaultValues={},
    isEdit,
    policies,
    items,
    index
  } = props;
  const [t] = useTranslation();
  const actionType = isEdit ? 'edit' : 'create';
  const methods = useForm({ defaultValues });

  const { control, handleSubmit, getValues, setError, setValue } = methods;
  const [languageSelected, setLanguageSelected] = useState('ini');
  const theme = useTheme();

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    p: 3,
    backgroundColor: 'white',
  };

  const srollBarStyles = {
    overflowY: 'scroll',
    maxHeight:'70vh',
    '&::-webkit-scrollbar': {
      width: '16px'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      backgroundColor: theme.palette.primary[100],
      border: `4px solid ${theme.palette.common.white}`,
      '&:hover': {
        backgroundColor: theme.palette.primary[200]
      },
      '&:active': {
        backgroundColor: theme.palette.primary[300]
      }
    }
  }

  const fields = [
    { policy: policies.modalHostName },
    { policy: policies.modalIpAddress },
    { policy: policies.modalNetworkType },
    { policy: policies.modalIsActive },
  ];

  const tagsField = {...policies.modalTags, defaultValues: getValues(policies.modalTags.name)};

  function handleOnSubmit(data) {

    const hostToSave = {
      name: data.modalHostName,
      ip: data.modalIpAddress,
      tags: data.modalTags,
      networkType: data.modalNetworkType,
      isActive: data.modalIsActive,
      variables: data.modalVariables,
      variablesType: languageSelected
    }

    if (isEdit) {
      onSubmitEdit({...hostToSave, index})
    } else {
      const hostFound = items.find(h => h.name === data.modalHostName && h.ip === data.modalIpAddress);
      if (hostFound) {
        setError(policies.modalHostName.name, {message: t('inventoryList.hosts.error.hostFound')});
        return;
      }
      onSubmitCreate(hostToSave);
    }
  }

  const handleOnChange = (name) => {
    return (value) => setValue(name, value);
  };

  const changeLanguage = (language) => {
    setLanguageSelected(language);
    setValue('language', language);
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      sx={{
        backdropFilter: 'blur(2px)',
      }}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
          <Paper sx={style}>
            <FormProvider { ...methods }>
            <form>
              <Grid container spacing={2} sx={srollBarStyles}>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography id="transition-modal-title" variant="h6" component="h2">
                    { t(`inventoryList.hosts.${actionType}.title`) }
                  </Typography>
                </Grid>

                { fields.map((field, index) => (
                  <Grid item key={index} xs={12} sm={12} md={4} lg={4} sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start'
                  }}>
                    <Input
                      {...field.policy}
                      control={control}
                      sx={{ width: '100%' }}
                    />
                  </Grid>
                ))}

                <Grid item xs={12} sm={12} md={12} lg={12} key={policies.modalTags.name}>
                  <FormChipList
                    {...tagsField}
                    control={control}
                    onChange={handleOnChange(tagsField.name)}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <FormMonacoEditor
                    label={policies.modalVariables.label}
                    name={policies.modalVariables.name}
                    helperText={policies.modalVariables.helperText}
                    methods={methods}
                    language={languageSelected}
                    handleSetLanguage={changeLanguage}
                    height='200px'
                  />
                </Grid>
              </Grid>

              <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                justifyContent: 'flex-end',
                gap: 2,
                mt: 2
              }}>
                <Button onClick={handleClose}>
                  { t(`template.stepper.polling.modal.buttonClose`) }
                </Button>
                <Button variant='contained' onClick={handleSubmit(handleOnSubmit)}>
                  { t(`template.stepper.polling.modal.${actionType}.button`) }
                </Button>
              </Box>
            </form>
          </FormProvider>
        </Paper>
      </Fade>
    </Modal>
  );
}
